import React, { useContext } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { ProgressContext, ProgressProvider } from './ProgressContext';
import { LoadingProvider, useLoading } from './ProgressContext';

const ProgressBar = () => {
//   const { loading } = useContext(ProgressContext);
  const { loading } = useLoading(); // Access loading state
  return (
    loading ? <LinearProgress color="error" /> : null
  );
};

export default ProgressBar;